// extracted by mini-css-extract-plugin
export default {"dialogActions":"GenericDialogFooter_dialogActions__xqH+v","dialogActions__secondary":"GenericDialogFooter_dialogActions__secondary__VPG9b"};